import { format, isSameDay, parseISO, isYesterday } from 'date-fns';
import { fr, enUS } from 'date-fns/locale';

export const shouldShowDateSeparator = (messages, index) => {
  if (index === 0) return true;

  const current = new Date(messages[index].Timestamp);
  const previous = new Date(messages[index - 1].Timestamp);

  return !isSameDay(current, previous);
};

export const getFormattedDateLabel = (timestamp, lang = 'fr') => {
  const date = new Date(timestamp);
  const today = new Date();

  if (isSameDay(date, today)) return lang === 'fr' ? "Aujourd’hui" : "Today";
  if (isYesterday(date)) return lang === 'fr' ? "Hier" : "Yesterday";
 console.log(format(date, 'd MMMM yyyy', { locale: lang === 'fr' ? fr : enUS }))
  return format(date, 'd MMMM yyyy', { locale: lang === 'fr' ? fr : enUS });
};
